<template>
  <RadioGroup v-model="selected">
    <RadioGroupLabel class="sr-only"> Document type </RadioGroupLabel>
    <div class="-space-y-px bg-white rounded-md">
      <RadioGroupOption
        as="template"
        v-for="(setting, settingIdx) in settings"
        :key="setting.name"
        :value="setting"
        v-slot="{ checked, active }"
      >
        <div
          :class="[
            settingIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
            settingIdx === settings.length - 1
              ? 'rounded-bl-md rounded-br-md'
              : '',
            checked ? 'bg-red-50 border-red-200 z-10' : 'border-gray-200',
            'relative border p-4 flex cursor-pointer focus:outline-none',
          ]"
        >
          <span
            :class="[
              checked
                ? 'bg-red-600 border-transparent'
                : 'bg-white border-gray-300',
              active ? 'ring-2 ring-offset-2 ring-red-500' : '',
              'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center',
            ]"
            aria-hidden="true"
          >
            <span class="rounded-full bg-white w-1.5 h-1.5" />
          </span>
          <div class="flex flex-col ml-3">
            <RadioGroupLabel
              as="div"
              :class="[
                checked ? 'text-red-900' : 'text-gray-900',
                'block text-sm font-medium space-x-8 inline-flex items-center',
              ]"
            >
              <span>{{ t("application.docs." + setting.key) }}</span>
              <a
                class="px-3 py-1 text-xs text-white bg-green-500 rounded-md text-bold"
                target="_blank"
                v-if="setting.key === 'personal_net_worth_statement'"
                :href="t('application.docs.' + setting.key + '_pdf')"
                >{{ t("download") }}</a
              >
            </RadioGroupLabel>
            <RadioGroupDescription
              as="span"
              :class="[
                checked ? 'text-red-700' : 'text-gray-500',
                'block text-sm hidden',
              ]"
            >
              {{ setting.description }}
            </RadioGroupDescription>
          </div>
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import {
  RadioGroup,
  RadioGroupDescription,
  RadioGroupLabel,
  RadioGroupOption,
} from "@headlessui/vue";
import { useI18n } from "vue-i18n";

const settings = [
  {
    id: 65,
    name: "Business Plan",
    description: "This project would be available to anyone who has the link",
    key: "business_plan_file",
  },
  {
    id: 66,
    name: "Financial Statement",
    description: "Only members of this project would be able to access",
    key: "financial_statement_file",
  },
  {
    id: 53,
    name: "Personal Net worth Statement",
    description: "Only members of this project would be able to access",
    key: "personal_net_worth_statement",
  },
  {
    id: 71,
    name: "Tax notice of Assessment",
    description: "You are the only one able to access this project",
    key: "income_tax_filed_up_to_date_file",
  },
];

export default {
  components: {
    RadioGroup,
    RadioGroupDescription,
    RadioGroupLabel,
    RadioGroupOption,
  },
  setup(props, { emit }) {
    const selected = ref(settings[0]);

    const { t } = useI18n();

    onMounted(() => {
      selected.value = settings[0];
      emit("updated", selected.value);
    });

    watch(selected, (value) => {
      emit("updated", value);
    });

    return {
      settings,
      t,
      selected,
    };
  },
};
</script>
